module.exports = __webpack_public_path__ + "img/upgrade_tips.png";